import InAppMessage from "./in-app-message.js";
import E from "../../managers/subscription-manager.js";
export default class InAppMessageButton {
  constructor(s, t, i, r, h, e, n) {
    (this.text = s),
      (this.backgroundColor = t),
      (this.textColor = i),
      (this.borderColor = r),
      (this.clickAction = h),
      (this.uri = e),
      (this.id = n),
      (this.text = s || ""),
      (this.backgroundColor = t || InAppMessage.th.sh),
      (this.textColor = i || InAppMessage.th.ih),
      (this.borderColor = r || this.backgroundColor),
      (this.clickAction = h || InAppMessage.ClickAction.NONE),
      (this.uri = e),
      null == n && (n = InAppMessageButton.Yi),
      (this.id = n),
      (this.do = !1),
      (this.ht = new E());
  }
  subscribeToClickedEvent(s) {
    return this.ht.lt(s);
  }
  removeSubscription(s) {
    this.ht.removeSubscription(s);
  }
  removeAllSubscriptions() {
    this.ht.removeAllSubscriptions();
  }
  p() {
    return !this.do && ((this.do = !0), this.ht.Et(), !0);
  }
  static fromJson(s) {
    return new InAppMessageButton(
      s.text,
      s.bg_color,
      s.text_color,
      s.border_color,
      s.click_action,
      s.uri,
      s.id,
    );
  }
}
InAppMessageButton.Yi = -1;
